<app-button-export-to-excel 
    *ngIf="data && data.length > 0"
    fileName="Nom Org Representatives"
    [schema]="exportSchema" 
    [data]="data"
    id="btn-export-nom-org-representatives"
    label="Export"
></app-button-export-to-excel>